module.exports = __webpack_public_path__ + "img/green-check.9238226a.svg";